@if (isLoading()) {
  <div
    class="fixed inset-0 z-50"
    (click)="closeOverlay()"
    (keyup.enter)="closeOverlay()"
    [@overlayAnimations]
    style="z-index: 1103"
    tabindex="2"
  >
    <div class="fixed inset-0 bg-gray-700 bg-cover bg-fixed bg-center"></div>
    @if (image()) {
      <div
        class="background-image fixed inset-0 z-40 bg-gray-800 bg-cover bg-fixed bg-center bg-no-repeat brightness-75 saturate-100 filter dark:brightness-50"
        [ngStyle]="{ 'background-image': 'url(' + image() + ')' }"
        [@fadeIn]
      ></div>
    }

    <div class="fixed inset-0 z-50 overflow-y-auto">
      <div
        class="flex min-h-full flex-col items-center justify-center p-4 text-center sm:items-center sm:p-0"
      >
        <div class="spinner-wrapper">
          <div class="spinner"></div>

          <div class="spinner-section section-left"></div>
          <div class="spinner-section section-right"></div>
        </div>
        <p class="text-sm text-white">{{ loading }}</p>
        <div
          class="mb-4 mt-4 h-1.5 w-64 rounded-full bg-gray-500 opacity-75 filter dark:bg-gray-700"
        >
          <div
            class="progress-bar h-1.5 rounded-full bg-gray-100 opacity-75 filter dark:bg-white"
          ></div>
        </div>
      </div>
    </div>
  </div>
}

@if (loadingImage) {
  <img
    class="absolute left-72 h-0 overflow-hidden"
    [src]="loadingImage"
    (error)="handleError()"
    (load)="handleLoad()"
    alt="Loading"
    aria-hidden="true"
  />
}
